import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import { BaseGeneralConfig, GeneralPartConfig } from "../../general-scenario-stuff";
import { GeneralStepCollection } from "../../GeneralStepCollection";
import GeneralProceduresCricPart1 from "./parts/GeneralProceduresCricPart1";
import GeneralProceduresCricPart2 from "./parts/GeneralProceduresCricPart2";
import GeneralProceduresCricPart3 from "./parts/GeneralProceduresCricPart3";
import GeneralProceduresCricPart4 from "./parts/GeneralProceduresCricPart4";
import GeneralProceduresCricPart5 from "./parts/GeneralProceduresCricPart5";
import GeneralProceduresCricPart6 from "./parts/GeneralProceduresCricPart6";
import GeneralProceduresCricPart7 from "./parts/GeneralProceduresCricPart7";
import GeneralProceduresCricPart8 from "./parts/GeneralProceduresCricPart8";
import GeneralProceduresCricPart9 from "./parts/GeneralProceduresCricPart9";

export default class GeneralProceduresCricMain extends GeneralStepCollection {
	private _parts: BaseScenarioPart<DaarcBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	private _partId2 = getNextPartId();
	private _partId3 = getNextPartId();
	private _partId4 = getNextPartId();
	private _partId5 = getNextPartId();
	private _partId6 = getNextPartId();
	private _partId7 = getNextPartId();
	private _partId8 = getNextPartId();
	private _partId9 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: GeneralProceduresCricMainConfig) {
		super();
		var context = this;
		context._parts.push(new GeneralProceduresCricPart1(config.scenario, () => {
			if(context.config.scenario.isLite) {
				context.goToStep9()
			} else {
				context.goToStep2();
			}
		}, context._partId1, config));
		context._parts.push(new GeneralProceduresCricPart2(config.scenario, () => {
			context.goToStep3();
		}, context._partId2, config))
		context._parts.push(new GeneralProceduresCricPart3(config.scenario, 
		() => { //onScalpelSelected
			context.goToStep4();
		}, () => { //onSpreaderSelected
			context.goToStep5();
		}, () => { //onBougieSelected
			context.goToStep6();
		}, () => { //onEttSelected
			context.goToStep7();
		}, () => { //onSyringeSelected
			context.goToStep8();
		}, () => { //onAbortClicked
			if(context.config.onAbort) {
				context.config.onAbort();
			}
		}, context._partId3, config))

		context._parts.push(new GeneralProceduresCricPart4(config.scenario, () => {
			context.goToStep3();
		}, context._partId4, config));

		context._parts.push(new GeneralProceduresCricPart5(config.scenario, () => {
			context.goToStep3();
		}, context._partId5, config));

		context._parts.push(new GeneralProceduresCricPart6(config.scenario, () => {
			context.goToStep3();
		}, context._partId6, config));

		context._parts.push(new GeneralProceduresCricPart7(config.scenario, () => {
			context.goToStep3();
		}, context._partId7, config));

		context._parts.push(new GeneralProceduresCricPart8(config.scenario, () => {
			config.onDone();
		}, context._partId8, config));

		if(context.config.scenario.isLite) {
			context._parts.push(new GeneralProceduresCricPart9(config.scenario, () => {
				config.onDone();
			}, context._partId9, config));
		}
	}

	public start() {
		this.goToStep1();
	}

	goToStep1() {
		this.config.scenario.loadPart(this._partId1);
	}

	goToStep2() {
		this.config.scenario.loadPart(this._partId2);
	}

	goToStep3() {
		this.config.scenario.loadPart(this._partId3);
	}

	goToStep4() {
		this.config.scenario.loadPart(this._partId4);
	}

	goToStep5() {
		this.config.scenario.loadPart(this._partId5);
	}

	goToStep6() {
		this.config.scenario.loadPart(this._partId6);
	}

	goToStep7() {
		this.config.scenario.loadPart(this._partId7);
	}

	goToStep8() {
		this.config.scenario.loadPart(this._partId8);
	}

	goToStep9() {
		if(this.config.scenario.isLite) {
			this.config.scenario.loadPart(this._partId9);
		}
	}
}

export interface GeneralProceduresCricMainConfig extends BaseGeneralConfig {
	scenario: DaarcBaseScenario;
	part1Config?: GeneralProceduresCricPart1Config;
	part2Config?: GeneralProceduresCricPart2Config;
	part3Config?: GeneralProceduresCricPart3Config;
	part4Config?: GeneralProceduresCricPart4Config;
	part5Config?: GeneralProceduresCricPart5Config;
	part6Config?: GeneralProceduresCricPart6Config;
	part7Config?: GeneralProceduresCricPart7Config;
	part8Config?: GeneralProceduresCricPart8Config;
	part9Config?: GeneralProceduresCricPart9Config;
	isAttemptSuccessful: () => boolean;
	isCricScenario?: boolean;
	onDone: () => void;
	onAbort: () => void;
}

export interface GeneralProceduresCricPart1Config extends GeneralPartConfig {
	correctToolOrder: string[];
}

export interface GeneralProceduresCricPart2Config extends GeneralPartConfig {
	identifyLandmarksVideoChapter: () => string;
	identifyLandmarksIncorrectMessages?: string[];
	identifyLandmarksFailedMessage?: string;
	areLandmarksObstructed?: boolean;
	landmarksObstructedMessageTitle?: string;
	landmarksObstructedMessageText?: string;
	onLandmarksFinished?: (isCorrect: boolean) => void;
	onSingleLandmarkSelected?: (isCorrect: boolean) => void;
}

export interface GeneralProceduresCricPart3Config extends GeneralPartConfig {
}

export interface GeneralProceduresCricPart4Config extends GeneralPartConfig {
	scalpelVideoChapter: () => string;
	onMakingIncition?: () => void;
	onKeepScalpelInPlaceClicked?: () => void;
	onRemoveScalpelClicked?: () => void;
}

export interface GeneralProceduresCricPart5Config extends GeneralPartConfig {
	onInsertingSpreader?: () => void;
	spreaderVideoChapter: () => string;
}

export interface GeneralProceduresCricPart6Config extends GeneralPartConfig {
	bougieVideoChapter: () => string;
	onInsertionAngleNextClicked?: (selectedAngleIndx: number, selectedDepth: number) => void;
}

export interface GeneralProceduresCricPart7Config extends GeneralPartConfig {
	etTubeVideoChapter: () => string;
	onEtOptionsUIClosed?: (selectedDepth: number) => void;
}

export interface GeneralProceduresCricPart8Config extends GeneralPartConfig {
	squeezeAmbuBagVideoChapter: () => string;
}

export interface GeneralProceduresCricPart9Config extends GeneralPartConfig {
	onYesClicked: () => void;
	onNoClicked: () => void;
}